import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Chip, Grid, Label } from '@as/cotopaxi';
import { setTooltip } from '@as-react/common-utils';
import { Box } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
export const ProductVariantButtons = ({ productVariants, handleVariantClick, productCode, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const setTooltipElement = () => {
        productVariants.map(({ productCodeVariants }, vIndex) => productCodeVariants.map((_, cIndex) => setTooltip({
            element: `#product-variant-button-${vIndex}-disabled-${cIndex}`,
            content: t('pdp.combination.not.available'),
            showCloseButton: false,
            optionsOverride: {
                placement: 'bottom',
            },
        })));
    };
    useEffect(() => setTooltipElement(), []);
    return (_jsx(_Fragment, { children: productVariants.map(({ variantType, productCodeVariants }, vIndex) => (_jsxs(Box, { paddingBlockEnd: "4", children: [_jsxs(Label, { emphasized: true, children: [variantType, ":"] }), _jsx(Box, { paddingBlockStart: "2", children: _jsx(Grid, { scalable: {
                            min: `${Math.max(...productCodeVariants.map(code => code.variantValue.length))}ch`,
                            maxCols: productCodeVariants.length <= 2 ? { mobile: 2, desktop: 3 } : { mobile: 4, desktop: 5 },
                            repeatPattern: productCodeVariants.length <= 2 ? 'auto-fill' : undefined,
                        }, gap: "s", dataQA: "product-variant-buttons", children: productCodeVariants.map((variant, cIndex) => (_jsx(Chip, { id: `product-variant-button-${vIndex}-${variant.productCode || `disabled-${cIndex}`}`, text: variant.variantValue, state: !variant.productCode ? 'disabled' : productCode === variant.productCode ? 'activated' : 'enabled', onClick: variant.productCode && variant.productSeoUrl && productCode !== variant.productCode
                                ? handleVariantClick(variant)
                                : undefined, noInlinePadding: true }, variant.productCode || `${variantType}-${cIndex}`))) }) })] }, variantType))) }));
};
